import { Browser } from "@capacitor/browser";
import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

interface OpenProps {
  readonly url: string;
}

interface UseBrowserResult {
  readonly open: UseMutationResult<void, Error, OpenProps>;
}

export function useBrowser(): UseBrowserResult {
  return {
    open: useMutation({
      mutationFn: async ({ url }) => {
        await Browser.open({ url });
      },
    }),
  };
}
